<script>
  import { validateAtInput } from '../utils.js';
  import {sgettext} from '../../../i18n.js';

  export let value = '';
  export let id = '';
  export let key = '';
  export let label = '';
  export let placeholder = '';
  export let required = false;
  export let isValid = true;
  export let errors = '';
  export let schema = null;
  export let floatClass = '';
  export let additionalClass = '';
  export let hidden = false;
  export let object = {};
  export let help = '';

  let touched = false;

  if(!key){
      key = id;
  }

  async function handleOnBlur(event){
    try {
      if( schema && schema.fields.hasOwnProperty(key)) {
        await validateAtInput(schema, key, object);
        isValid = true;
        errors = '';
      }
    } catch(err) {
      isValid = false;
      errors = err.message;
    }
  }
</script>

<style>
  .errors {
    color: #dc3545;
    font-size: 13px;
  }

  .text-input {
    height: 44px;
  }

  .invalid {
    border-color: #dc3545;
  }
</style>


{#if label}
<label for={id} title={required ? sgettext('$$FIELD_REQUIRED$$') : ''}>{label}</label>
{/if}

<input
  draggable={true}
  on:dragstart={(ev) => ev.preventDefault()}
  type="password"
  autocomplete="off"
  {id}
  class:invalid={!isValid}
  {placeholder}
  class="form-control text-input {floatClass} {additionalClass}"
  class:hidden={hidden}
  bind:value
  on:change
  on:input
  on:focus={() => (touched = true)}
  on:blur={handleOnBlur}
   />

{#if help}
    <small class="form-text text-muted">{help}</small>
{/if}
{#if !isValid}
  <div class="errors">{errors}</div>
{/if}

